import { z } from "zod";

// `bay_budget`: a job's clocked-in bay time passed two shifts (TRBUD-424).
export const notificationKinds = ["self_claim", "assignment", "comment", "repair_complete", "request", "purchase_order", "clock_exception", "bay_budget"] as const;
export type NotificationKind = typeof notificationKinds[number];
export const notificationsQuery = z.object({
  offset: z.coerce.number().int().min(0).max(1000000).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  unreadOnly: z.enum(["true", "false"]).default("false").transform((value) => value === "true"),
}).strict();
export const notificationReadBody = z.object({}).strict();
export interface NotificationItem {
  id: string; kind: NotificationKind; occurredAt: string; readAt: string | null;
  title: string; body: string; href: string;
}
export interface NotificationsResponse {
  items: NotificationItem[]; unreadCount: number; total: number; hasMore: boolean;
}
